module.exports = __webpack_public_path__ + "img/stretch--genre1_tab-normal.b7f98ab1.png";